import Swiper, { Navigation, Pagination } from 'swiper';
import { useTranslation } from 'react-i18next'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Testimonials = () => {
    const { t } = useTranslation()

    const testimonial = [
        {
            id: 1,
            author: 'Quinta Silveria',
            title: 'testimonial_title1',
            stars: [1, 2, 3, 4, 5],
            description: 'testimonial_quinta_silveria',
        }, 
        {
            id: 2,
            author: 'Villa Bárbara',
            title: 'testimonial_title2',
            stars: [1,2,3,4],
            description: 'testimonial_villa_barbara',
        }, 
        {
            id: 3,
            author: 'Walls Of Hope',
            title: 'testimonial_title3',
            stars: [1, 2, 3, 4, 5],
            description: 'testimonial_walls_of_hope',
        }, 
        {
            id: 4,
            author: 'Diesel Avenida',
            title: 'testimonial_title4',
            stars: [1, 2, 3, 4, 5],
            description: 'testimonial_diesel_avenida',
        }, 
    ]

    const swiper = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 32,
        autoplay: {
            delay: 8000,
        },
        breakpoints: {
            640: {
            centeredSlides: true,
            slidesPerView: 1.25,
            },
            1024: {
            centeredSlides: false,
            slidesPerView: 1.5,
            },
        },
        navigation: {
            nextEl: '.next-button',
            prevEl: '.prev-button',
        },
    })

    return (
        <div>
            <section>
                <div className="mx-auto px-4 pt-16 sm:px-6 sm:py-24 lg:mr-0 lg:pl-8 lg:pr-0">
                    <div className="">
                        <div className="text-center sm:text-lef">
                            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">{ t('testimonial_heading') }</h2>

                            <p className="mt-4 text-gray-500">{ t('testimonial_subheading') }</p>

                            <div className="mt-8 justify-center flex gap-4">
                                <button className="prev-button rounded-full border border-indigo-500 p-3 text-indigo-500 hover:bg-indigo-500 hover:text-white">
                                    <span className="sr-only">Previous Slide</span>
                                    <svg className="h-5 w-5 -rotate-180 transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                    </svg>
                                </button>

                                <button className="next-button rounded-full border border-indigo-500 p-3 text-indigo-500 hover:bg-indigo-500 hover:text-white">
                                    <span className="sr-only">Next Slide</span>
                                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                                        <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                    </svg>
                                </button>
                            </div>
                    </div>

                    <div className="lg:col-span-2 lg:mx-0">
                            <div className="swiper-container w-full overflow-hidden">
                                <div className="swiper-wrapper">
                                    {testimonial.map((item) => (
                                        <div key={item.id} className="swiper-slide">
                                            <blockquote className="flex mt-4 h-full flex-col justify-evenly bg-white p-12">
                                                <div>
                                                    <div className="flex gap-0.5 text-indigo-500">
                                                        {item.stars.map((e, index) => {
                                                            return(
                                                                <svg key={index} className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                                                </svg>
                                                            )
                                                        })}
                                                    </div>

                                                    <div className="mt-4">
                                                        <p className="text-2xl font-bold text-bk sm:text-3xl">
                                                        { t(item.title) }
                                                        </p>

                                                        <p className="mt-4 leading-relaxed text-gray-500">
                                                            { t(item.description) }
                                                        </p>
                                                    </div>
                                                </div>
                                                <footer className="mt-8 text-sm text-gray-500">{item.author}</footer>
                                            </blockquote>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Testimonials